import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M33.135 43.383a1 1 0 0 0 1.333.472A22 22 0 0 0 47 23.991 22 22 0 0 0 34.403 4.096a1 1 0 0 0-.856 1.808A20 20 0 0 1 45 23.991a20 20 0 0 1-11.394 18.06 1 1 0 0 0-.471 1.332m-1.892-4.487a1 1 0 0 0 1.38.31A17.99 17.99 0 0 0 41 23.99c0-6.294-3.258-12.03-8.504-15.294a1 1 0 0 0-1.056 1.698c4.665 2.903 7.56 8 7.56 13.596 0 5.55-2.846 10.61-7.448 13.525a1 1 0 0 0-.31 1.38m-.522-4.83a1 1 0 1 1-1.39-1.439A11.96 11.96 0 0 0 33 23.991a11.96 11.96 0 0 0-3.732-8.697 1 1 0 0 1 1.378-1.45A13.96 13.96 0 0 1 35 23.992a13.96 13.96 0 0 1-4.28 10.075M1.037 25.364a7 7 0 0 0 6.99 6.623h3.478l1.397 1.578a61 61 0 0 0 7.49 7.14l1.152.925a3 3 0 0 0 4.866-2.064Q27 33.15 27 23.987q0-9.167-.59-15.583a3 3 0 0 0-4.864-2.066l-1.1.883a60.6 60.6 0 0 0-7.397 7.03l-1.542 1.736h-3.48a7 7 0 0 0-6.99 6.622 26 26 0 0 0 0 2.755M11 17.987H8.027a5 5 0 0 0-4.993 4.73 24 24 0 0 0 0 2.54 5 5 0 0 0 4.993 4.73H11zm2-.67v13.341l1.4 1.581a59 59 0 0 0 7.244 6.906l1.153.926a1 1 0 0 0 1.622-.688q.58-6.316.581-15.396 0-9.083-.582-15.4a1 1 0 0 0-1.62-.689l-1.102.883a58.6 58.6 0 0 0-7.152 6.798z",
      clipRule: "evenodd"
    }
  )
);
var SvgSoundHighOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SoundHighOutlined_default = SvgSoundHighOutlined;

export { SoundHighOutlined_default as default };
